import ShoveberryModal from "./ShoveberryModal";

export default ShoveberryModal;
